module.exports = __webpack_public_path__ + "img/BungkusIT.3260267e.png";